import { IcDots } from '@proton/icons/icons/IcDots';

export const Handle = () => {
    return (
        <span className="flex" data-testid="table:order-icon">
            <IcDots className="my-auto cursor-grab color-hint" />
        </span>
    );
};
